import { addNode } from "../utils/flowSlice";
import { useDispatch } from "react-redux";
import { useContext, useState } from "react";
import { DarkModeContext } from "../context/DarkModeContext";
import { Folder } from "lucide-react";

const Group = () => {
  const dispatch = useDispatch();
  const handleButtonClick = async () => {
    dispatch(addNode({ type: "groupNode" }));
  };
  const { darkMode } = useContext(DarkModeContext);

  // State to track hover for each icon
  const [activeTooltip, setActiveTooltip] = useState(null);

  const handleMouseEnter = (id) => {
    setActiveTooltip(id);
  };

  const handleMouseLeave = () => {
    setActiveTooltip(null);
  };

  return (
    <div
      className="rounded-lg flex justify-center items-center relative hover:cursor-pointer"
      onMouseEnter={() => handleMouseEnter("group")}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={`w-10 h-10 mt-0.5 mx-0.5 flex items-center justify-center rounded-full transition opacity-50 ${darkMode ? "text-neutral-600" : "text-white"
          }`}
        onClick={handleButtonClick}
      >
        <Folder size={20} />
      </button>
      {activeTooltip === "group" && (
        <span className="absolute left-full ml-2 whitespace-nowrap bg-gray-700 text-white text-xs rounded py-1 px-2 z-10">
          Group
        </span>
      )}
    </div>
  );
};

export default Group;
